/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CloneProgramTemplatesPathParameters,
  CloneProgramTemplatesRequest,
  CreateProgramTemplatePathParameters,
  CreateTouchpointsFromTemplatesRequest,
  GetAllProgramTemplatesParams,
  GetAllProgramTemplatesPathParameters,
  GetApprovedProgramTemplatesParams,
  GetApprovedProgramTemplatesPathParameters,
  PagedModelCampaignTouchpointSummaryDTO,
  ProgramTemplateCreateRequest,
  TouchpointDTO,
  TouchpointVersionBaseDTO,
  TouchpointsFromTemplatesPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getProgramTemplates = () => {
  /**
 * Get all touchpoints for campaign

Required authority: PERM_TOUCHPOINT_READ
 */
  const getAllProgramTemplates = (
    { clientId }: GetAllProgramTemplatesPathParameters,
    params?: GetAllProgramTemplatesParams,
  ) => {
    return customInstance<PagedModelCampaignTouchpointSummaryDTO>({
      url: `/api/clients/${clientId}/program-templates`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a program template

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const createProgramTemplate = (
    { clientId }: CreateProgramTemplatePathParameters,
    programTemplateCreateRequest: ProgramTemplateCreateRequest,
  ) => {
    return customInstance<TouchpointDTO>({
      url: `/api/clients/${clientId}/program-templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: programTemplateCreateRequest,
    });
  };
  /**
 * Create touchpoints from templates

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const touchpointsFromTemplates = (
    { clientId }: TouchpointsFromTemplatesPathParameters,
    createTouchpointsFromTemplatesRequest: CreateTouchpointsFromTemplatesRequest,
  ) => {
    return customInstance<TouchpointDTO[]>({
      url: `/api/clients/${clientId}/program-templates/touchpoints-from-template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTouchpointsFromTemplatesRequest,
    });
  };
  /**
 * Clone one or more program templates within the Program Templates campaign

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const cloneProgramTemplates = (
    { clientId }: CloneProgramTemplatesPathParameters,
    cloneProgramTemplatesRequest: CloneProgramTemplatesRequest,
  ) => {
    return customInstance<TouchpointDTO[]>({
      url: `/api/clients/${clientId}/program-templates/clone`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cloneProgramTemplatesRequest,
    });
  };
  /**
 * Get program templates of the given type with their latest approved or published version, ordered by name. Touchpoint type is specified using the 'type' query param. Accepted values: 'EMAIL', 'LANDING_PAGE'

Required authority: PERM_TOUCHPOINT_READ
 */
  const getApprovedProgramTemplates = (
    { clientId }: GetApprovedProgramTemplatesPathParameters,
    params: GetApprovedProgramTemplatesParams,
  ) => {
    return customInstance<TouchpointVersionBaseDTO[]>({
      url: `/api/clients/${clientId}/program-templates/approved`,
      method: "GET",
      params,
    });
  };
  return {
    getAllProgramTemplates,
    createProgramTemplate,
    touchpointsFromTemplates,
    cloneProgramTemplates,
    getApprovedProgramTemplates,
  };
};
export type GetAllProgramTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getProgramTemplates>["getAllProgramTemplates"]>>
>;
export type CreateProgramTemplateResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getProgramTemplates>["createProgramTemplate"]>>
>;
export type TouchpointsFromTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getProgramTemplates>["touchpointsFromTemplates"]>>
>;
export type CloneProgramTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getProgramTemplates>["cloneProgramTemplates"]>>
>;
export type GetApprovedProgramTemplatesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getProgramTemplates>["getApprovedProgramTemplates"]>>
>;
